import * as React from "react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from "styled-components";

import { validate } from "src/CustomHooks/useDateConverter";

import Button from "src/SharedComponents/Button";
import DateInput from "src/SharedComponents/DateInput";
import LoadingIndicator from "src/SharedComponents/LoadingIndicator";
import TextInput from "src/SharedComponents/TextInput";

import attemptLogin, { ILoginDetails } from "./loginService";
import { SessionContext } from "./SessionContext";


interface IProps extends RouteComponentProps<{}> {
    token: string
};

const Logo = styled.img`
    margin: 10px 0 50px 10px;
`;

const LoginForm = styled.form`
    margin: 0 24px;
`;

const InstructionText = styled.p`
    margin: 0;
    font-size: 1.6rem;
    font-weight: 600;
`;

const ErrorContainer = styled.div`
    padding: 24px 12px;
`;

const Login = (props: IProps) => {
    const [token, setToken] = React.useState(props.token !== "token" ? props.token : "");
    const isParent = new URLSearchParams(window.location.search).get("parent");
    const [error, setError] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const sessionContext = React.useContext(SessionContext);
    const [day, setDay] = React.useState("");
    const [month, setMonth] = React.useState("");
    const [year, setYear] = React.useState("");
    const [code, setCode] = React.useState("");

    const loginSuccessCallback = (result: ILoginDetails) => {
        sessionContext.dispatch({ type: "setPage", payload: { formId: result.formId, page: 1 } });
        sessionContext.dispatch({ type: "setWebToken", payload: result.token });
    };

    const loginFailureCallback = (errorMessage: string) => {
        setLoading(false);
        setError(errorMessage);
    };

    const startTokenSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const dob = getDateFromParts(day, month, year);
        setLoading(true);
        attemptLogin(token, dob.getTime().toString(), loginSuccessCallback, loginFailureCallback);
    }

    const getDateFromParts = (dayIn: string, monthIn: string, yearIn: string) => {
        if (yearIn && monthIn && dayIn) {
            return new Date(parseInt(yearIn, 10), parseInt(monthIn, 10) - 1, parseInt(dayIn, 10));
        }
        return new Date();
    };

    const invalidDate = !validate((!month && !year) ? "" : day, month, year, false);

    const changeNumeric = (setter: (value: string) => void) => (e: React.SyntheticEvent<HTMLInputElement>) => {
        if (parseInt(e.currentTarget.value, 10) > -1 || e.currentTarget.value === "") {
            setter(e.currentTarget.value);
        }
    };

    const changeCode = (event: React.SyntheticEvent<HTMLInputElement>) => {
        setCode(event.currentTarget.value);
    };

    const submitCode = () => {
        setToken(code);
    };

    return <div>
        <Logo className="logo" src={"/images/safe_logo.png"} alt="SAFE Secure self assessment forms"/>
        {!token && <LoginForm>
            <InstructionText>Enter your code</InstructionText>
            <TextInput
                width={"25%"}
                maxLength={8}
                value={code}
                onChange={changeCode} label={""}
            />
            {!loading && <Button
                margin="10px 0"
                text="Submit code"
                onClick={submitCode}
            />}
        </LoginForm>
        }
        {token && <LoginForm onSubmit={startTokenSearch}>
            <InstructionText>{isParent ? "Enter your child's date of birth" : "Enter your date of birth"}</InstructionText>
            <DateInput
                invalid={!!(invalidDate && day && month && year)}
                day={day}
                month={month}
                year={year}
                DayChanged={changeNumeric(setDay)}
                MonthChanged={changeNumeric(setMonth)}
                YearChanged={changeNumeric(setYear)}
            />
            {loading && <LoadingIndicator />}
            {!loading && <Button
                margin="10px 0"
                text="View form"
                submit={true}
                disabled={invalidDate} />}
        </LoginForm>
        }
        <ErrorContainer>{error}</ErrorContainer>
    </div>;
};

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/Views/Login.tsx